import React from 'react';
import { motion } from 'framer-motion';
import { MessageSquare, Clock } from 'lucide-react';
import { categoryLabels, ForumThreadRow } from './forumLabels';

type Props = {
  thread: ForumThreadRow;
  onClick: () => void;
};

function excerpt(text: string, max = 120) {
  const t = text.replace(/\s+/g, ' ').trim();
  return t.length <= max ? t : `${t.slice(0, max)}…`;
}

const ForumThreadCard: React.FC<Props> = ({ thread, onClick }) => (
  <motion.button
    type="button"
    whileHover={{ y: -2 }}
    whileTap={{ scale: 0.995 }}
    onClick={onClick}
    className="forum-thread-card glow-card"
  >
    <div className="forum-thread-card__top">
      <span className="forum-badge">{categoryLabels[thread.category] || thread.category}</span>
      <span className="forum-thread-card__meta">
        <MessageSquare size={13} />
        {thread.replyCount} yanıt
      </span>
    </div>
    <h3 className="forum-thread-card__title">{thread.title}</h3>
    <p className="forum-thread-card__excerpt">{excerpt(thread.content)}</p>
    <div className="forum-thread-card__footer">
      <span>{thread.author?.name || 'Üye'}</span>
      <span className="forum-thread-card__time">
        <Clock size={12} />
        {new Date(thread.createdAt).toLocaleDateString('tr-TR')}
      </span>
    </div>
  </motion.button>
);

export default ForumThreadCard;
